import { __assign, __awaiter, __generator } from "tslib";
import { getThreeDsChallengeDisplaySize, renderIframeAndWaitForPostback, ThreeDsFormattingException, } from '../3d-secure';
import { decodeBase64URL, encodeBase64URL } from '../base64url';
import { stringify } from '../../../utils';
import { logTaggedMessage } from '../../reporter';
import { threeDsErrors } from '../3ds-utils';
import { removeChallengeIframe } from '../iframe-handler';
var log = logTaggedMessage({
    module: '3ds',
    sub_moodule: 'adyen-challenge',
});
export var performChallenge = function (_a) {
    var actionData = _a.data, methodUrl = _a.methodUrl, provider = _a.provider;
    return __awaiter(void 0, void 0, void 0, function () {
        var challengeDisplaySize, _b, threeDSServerTransID, acsTransID, messageVersion, threeDS2Token, dataToServer, success, fail, requestData, requestRawPostData, logData, ret, resultPromise, challengeResult, err, ret, e_1, ret;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    challengeDisplaySize = getThreeDsChallengeDisplaySize();
                    _b = actionData, threeDSServerTransID = _b.threeDSServerTransID, acsTransID = _b.acsTransID, messageVersion = _b.messageVersion, threeDS2Token = _b.threeDS2Token;
                    dataToServer = {
                        token: threeDS2Token,
                    };
                    success = function () { return ({
                        challengeData: {
                            provider: provider,
                            received: {},
                            challengeDisplaySize: challengeDisplaySize,
                            data: dataToServer,
                        },
                    }); };
                    fail = function (error) {
                        return {
                            challengeData: {
                                challengeDisplaySize: challengeDisplaySize,
                                provider: provider,
                                notReceived: { error: error },
                                data: dataToServer,
                            },
                        };
                    };
                    requestData = {
                        challengeWindowSize: getAdyenChallengeSize(),
                        acsTransID: acsTransID,
                        threeDSServerTransID: threeDSServerTransID,
                        messageVersion: messageVersion,
                        messageType: 'CReq',
                    };
                    requestRawPostData = encodeRequestData(requestData);
                    logData = {
                        actionData: actionData,
                        methodUrl: methodUrl,
                        provider: provider,
                        challengeDisplaySize: challengeDisplaySize,
                        dataToServer: dataToServer,
                        requestData: requestData,
                        requestRawPostData: requestRawPostData,
                    };
                    log('3ds: before render 3ds Adyen challenge iframe', logData);
                    if (!methodUrl) {
                        ret = fail(threeDsErrors.missingUrl('ADYEN', 'challenge'));
                        log("3ds: Adyen Device Challenge failed", __assign(__assign({}, logData), { ret: ret }));
                        return [2 /*return*/, ret];
                    }
                    resultPromise = renderIframeAndWaitForPostback('visible', methodUrl, 'POST', requestRawPostData).then(parseChallengePostData);
                    _c.label = 1;
                case 1:
                    _c.trys.push([1, 3, 4, 5]);
                    return [4 /*yield*/, resultPromise];
                case 2:
                    challengeResult = _c.sent();
                    if (challengeResult.threeDSServerTransID !== threeDSServerTransID) {
                        err = "Adyen challengeResult transactionId dont match!\n      sent: ".concat(threeDSServerTransID, ",\n      recived: ").concat(challengeResult.threeDSServerTransID);
                        ret = fail(err);
                        log("3ds: Adyen Challenge failed", __assign(__assign({}, logData), { err: err, ret: ret }));
                        return [2 /*return*/, ret];
                    }
                    log('3ds: received Adyen Challenge success', __assign(__assign({}, logData), { challengeResult: challengeResult }));
                    return [2 /*return*/, success()];
                case 3:
                    e_1 = _c.sent();
                    ret = fail(threeDsErrors.generate3dsError({
                        providerFlow: 'ADYEN',
                        step: 'challenge',
                        e: e_1,
                    }));
                    log("3ds: Adyen Challenge failed", __assign(__assign({}, logData), { ret: ret, e: e_1 }));
                    return [2 /*return*/, ret];
                case 4:
                    removeChallengeIframe();
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    });
};
var encodeRequestData = function (data) {
    var encodedData = encodeBase64URL(JSON.stringify(data));
    var fields = {
        creq: encodedData,
    };
    return fields;
};
var parseChallengePostData = function (postData) {
    if (typeof postData !== 'object' ||
        !postData.cres) {
        throw new ThreeDsFormattingException("invalid ChallengeResponseRawPostData: (".concat(postData, ") ").concat(stringify(postData)));
    }
    var decoded;
    try {
        decoded = decodeBase64URL(postData.cres);
    }
    catch (e) {
        throw new ThreeDsFormattingException("failed to decode invalid ChallengeResponseRawPostData.cres: ".concat(stringify(postData)));
    }
    var parsedObj;
    try {
        parsedObj = JSON.parse(decoded);
    }
    catch (e) {
        throw new ThreeDsFormattingException("failed to JSON parse invalid decoded ChallengeResponseRawPostData.cres: ".concat(decoded));
    }
    if (typeof parsedObj.threeDSServerTransID !== 'string' ||
        parsedObj.transStatus !== 'Y') {
        throw new ThreeDsFormattingException("invalid ChallengeResponseData: ".concat(decoded));
    }
    return parsedObj;
};
var threeDsChallengeSizeToAdyenChallengeSize = function (_size) {
    var width = window.innerWidth ||
        document.documentElement.clientWidth ||
        document.body.clientWidth;
    var adyenChallengeWindowSize = width > 600
        ? '05'
        : width > 500
            ? '04'
            : width > 390
                ? '03'
                : width > 250
                    ? '02'
                    : '01';
    return adyenChallengeWindowSize;
};
var getAdyenChallengeSize = function () {
    return threeDsChallengeSizeToAdyenChallengeSize(getThreeDsChallengeDisplaySize());
};
//# sourceMappingURL=adyen-challenge.js.map